import { useState } from 'react';
import { Box, Card, CardContent, Typography, Tabs, Tab, Button } from '@mui/material';
import placeholderImage from '../../assets/img/placeholder-image.jpg';
import ModalContainerBox from './ModalContainerBox';
import IphoneBox from './IphoneBox';
import StyledBox from './StyledBox';

const NotificationShow = ({ title, content, urlImg, step, showJson, showModal,jsonData } : {title: string | null, content: string | null, urlImg: string | null, step: number, showJson: boolean, showModal: boolean,jsonData: any | null}) => {
  const [tab, setTab] = useState(0);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTab(newValue);
  };

  return (
    <Card sx={{ width: '32.5vw' }}>
      <CardContent>
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>

          {(step == 0 || step == 3)  && (
            <Tabs
            value={tab}
            onChange={handleTabChange}
            aria-label="Pestañas interactivas"
            sx={{ borderBottom: 1, borderColor: 'divider' }}
            >
                <Tab
                label="Estado Inicial"
                id="tab-0"
                aria-controls="tabpanel-0"
                sx={{
                    '&.Mui-selected': {
                    color: '#00A6E0', // Custom selected tab text color
                    },
                }}
                />
                <Tab
                label="Vista expandida"
                id="tab-1"
                aria-controls="tabpanel-1"
                sx={{
                    '&.Mui-selected': {
                    color: '#00A6E0', // Custom selected tab text color
                    },
                }}
                />
            </Tabs>
          )}

            

          
          {(step == 1 && showModal) && (
            <Typography variant="h6" component="h2" sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                Modal en Pantalla
            </Typography>
           )}

            {(step == 2 && showJson) && (
                <>
                    <Typography variant="h6" component="h2" sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    Datos del servicio
                    </Typography>
                    <pre
                        style={{
                        backgroundColor: '#f5f5f5',
                        padding: '10px',
                        borderRadius: '4px',
                        fontSize: '14px',
                        color: '#333',
                        whiteSpace: 'pre-wrap', // Preserve whitespace and wrap text
                        wordWrap: 'break-word', // Break long words to avoid overflow
                        overflowX: 'auto', // Allow horizontal scroll if necessary
                        overflowY: 'auto',
                        height: '60vh'
                        }}
                    >
                        {JSON.stringify(jsonData, null, 2)} {/* Beautify JSON */}
                    </pre>
                </>
            )}
          
        </Box>
        {(step == 1 && showModal) && (
            <>
            <ModalContainerBox>
                <Box
                sx={{
                    // border: '4px solid gray',
                    borderRadius: '12px',
                    display: 'flex',
                    flexDirection: 'column',
                    // justifyContent: tab == 1 ? 'left' : 'space-between',
                    alignItems: 'left',
                    width: '250px',
                    height: '325px',
                    // marginTop: '120px',
                    // marginLeft: '1vw',
                    padding: '5px',
                    position: 'absolute',  // Makes this box stack on top
                    zIndex: 1,  // Ensures it's layered over the other box
                    backgroundColor: 'white'
                }}
                > 
                    <Box
                        sx={{
                        position: 'absolute',
                        top: '-5px',
                        right: '-5px',
                        width: '25px',
                        height: '25px',
                        borderRadius: '50%',
                        backgroundColor: 'lightgray',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        cursor: 'pointer',
                        fontSize: '16px',
                        fontWeight: 'bold',
                        color: 'gray',
                        ':hover': {
                            backgroundColor: 'darkgray',
                            color: 'white'
                        }
                        }}
                    >
                        X
                    </Box>
                    <Box
                        sx={{
                        justifyContent: 'center',
                        display: 'flex',
                        flexDirection: 'column', // Stack items vertically
                        alignItems: 'center', // Center items horizontally
                        width: '100%',
                        paddingTop: '1vh',
                        // paddingLeft: '5vw', // Optional
                        }}
                    >
                        <Typography
                            style={{
                            fontSize: '12px', // Custom size
                            fontWeight: 'bold',
                            marginBottom: '2vh'
                            }}
                        >
                            {title}
                        </Typography>
                        <Typography
                            style={{
                            fontSize: '10px', // Custom size
                            fontWeight: 'normal',
                            justifyContent: 'center',
                            textAlign:'center',
                            marginLeft: '8px',
                            marginRight: '8px',
                            marginBottom:'8px'
                            }}
                        >
                            {content}
                        </Typography>
                        <img 
                            src={ (urlImg == null || urlImg == '') ? placeholderImage : urlImg} 
                            alt="icon" 
                            style={{ height: 'auto', width: '8vw' }} 
                        />
                    </Box>
                </Box>
            </ModalContainerBox>
            </>
        )}

        {(step == 0 || step == 3) && (
            <>
                <StyledBox>
                    <Box
                        sx={{
                        border: '4px solid gray',
                        borderRadius: '12px',
                        display: 'flex',
                        flexDirection: tab == 1 ? 'column' : 'row',
                        justifyContent: tab == 1 ? 'left' : 'space-between',
                        alignItems: 'left',
                        width: '340px',
                        height: tab == 1 ? '165px' : '80px',
                        marginTop: tab == 1 ? '200px' : '120px',
                        marginLeft: '15px',
                        padding: '5px'
                        }}
                    >
                        <Box>
                        <Typography
                            style={{
                                fontSize: '14px', // Custom size
                                fontWeight: 'bold'
                            }}
                        >
                            {title}
                        </Typography>
                        <Typography
                            style={{
                            fontSize: '10px', // Custom size
                            display: '-webkit-box', // Multi-line ellipsis for tab !== 1
                            WebkitBoxOrient: 'vertical',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            WebkitLineClamp: tab !== 1 ? 2 : 2, // Limit to 2 lines
                            }}
                        >
                            { content}
                        </Typography>
                        </Box>
                        { tab == 1 && (
                            <Box
                                sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                width: '100%',
                                height: '95px'
                                }}
                            >
                                <img 
                                src={ (urlImg == null || urlImg == '') ? placeholderImage : urlImg}
                                alt="icon" 
                                style={{ height: '100%', width: '100%', objectFit: 'contain' }} 
                                />
                            </Box>
                            )}
                        {tab == 0 && (
                        <img 
                        src={ (urlImg == null || urlImg == '') ? placeholderImage : urlImg}
                            alt="icon" 
                            style={{ height: '50px', width: '50px' }} 
                        />
                        )}
                        
                    </Box>
                </StyledBox>

                <Box sx={{justifyContent: 'center', alignItems:'center', width: '500px', display: 'flex',}}>
                    <Typography
                        style={{
                        marginTop: tab == 0 ? '30px' : '100px',
                        color: '#6B6C6C', // Custom size
                        }}
                    >
                    Android
                    </Typography>
                </Box>

                <IphoneBox>
                    <Box
                        sx={{
                        border: '4px solid gray',
                        display: 'flex',
                        borderRadius: '12px',
                        flexDirection: tab == 1 ? 'column' : 'row',
                        justifyContent: tab == 1 ? 'left' : 'space-between',
                        // alignItems: 'center',
                        width: '300px',
                        height: tab == 1 ? '180px' : '100px',
                        marginTop: tab == 1 ? '150px' : '70px',
                        marginLeft: '2.5px',
                        padding: '5px'
                        }}
                    >
                        { tab == 1 && (
                            <Box
                                sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                width: '100%',
                                height: '100px'
                                }}
                            >
                                <img 
                                src={ (urlImg == null || urlImg == '') ? placeholderImage : urlImg}
                                alt="icon" 
                                style={{ height: '100%', width: '50%', objectFit: 'contain' }} 
                                />
                            </Box>
                            )}
                        <Box
                            sx={{
                            marginTop: tab == 1 ? '0px' : '7.5px',
                            }}
                        >
                            <Typography
                                style={{
                                    fontSize: '14px', // Custom size
                                    fontWeight: 'bold'
                                }}
                            >
                                {title}
                            </Typography>
                            <Typography
                            style={{
                                fontSize: '10px', // Custom size
                                display: '-webkit-box', // Multi-line ellipsis for tab !== 1
                                WebkitBoxOrient: 'vertical',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                WebkitLineClamp: tab !== 1 ? 2 : 3, // Limit to 2 lines
                            }}
                            >
                            {content}
                            </Typography>
                        </Box>
                
                        { tab == 0 && (
                            <img 
                            src={ (urlImg == null || urlImg == '') ? placeholderImage : urlImg} 
                            alt="icon" 
                            style={{ height: '60px', width: '60px' }} 
                            />
                        )}  
                    </Box>
            </IphoneBox>

            <Box sx={{justifyContent: 'center', alignItems:'center', width: '500px', display: 'flex',}}>
                <Typography
                    style={{
                    marginTop: tab == 0 ? '30px' : '110px',
                    color: '#6B6C6C', // Custom size
                    }}
                >
                    Apple
                </Typography>
            </Box>
        </>
        )}
      </CardContent>
    </Card>
  );
};

export default NotificationShow;